<script lang="ts">
  let props = $props()
  let { score } = props
</script>

{#if score.total < 25}
  <p class="text-xl lg:text-2xl/8 font-bold text-gray-700">
    Your organization is not prepared to move fast, adapt, or lead through
    disruption. And if you’re honest, you already feel it:
  </p>
  <ul class="list-disc ml-4 lg:ml-8">
    <li class="mt-2 lg:mt-6 text-base lg:text-lg/7 text-gray-600">
      You can’t step away without risk
    </li>

    <li class="mt-1 lg:mt-6 text-base lg:text-lg/7 text-gray-600">
      Every decision flows through you
    </li>
    <li class="mt-1 lg:mt-6 text-base lg:text-lg/7 text-gray-600">
      Communication is vague, and follow-through is worse
    </li>
  </ul>
  <p
    class="text-base lg:text-lg/8 text-gray-700 mt-4 lg:mt-8 italic bg-blue-50 p-4 rounded"
  >
    You’re not leading a team - you’re dragging one uphill. And it’s burning you
    out.
  </p>
{:else if score.total >= 25 && score.total < 50}
  <p class="text-xl lg:text-2xl/8 text-gray-700 font-bold">
    This isn’t about embarrassment or blame. It’s about awareness.
  </p>
  <p class="text-base lg:text-lg/8 text-gray-700 mt-4 sm:mt-8">
    Your score signals something we see often: <span class="font-bold"
      >you’re leading through force of will, not through a system.</span
    > Your team gets things done - but mostly because you are the one pushing, deciding,
    catching, or stepping in.
  </p>
  <p class="text-base lg:text-lg/8 text-gray-700 mt-4 sm:mt-8">
    You’re not alone in this. But staying here isn’t sustainable.
  </p>
  <p
    class="text-base lg:text-lg/8 text-gray-700 mt-6 italic bg-blue-50 p-4 rounded"
  >
    Readiness isn’t how hard you work. It’s how well your team performs when you
    don’t.
  </p>
{:else if score.total >= 50 && score.total < 80}
  <p class="text-xl/8 lg:text-2xl/8 text-gray-700 font-bold">
    Here’s the hard truth: the pace of change is only accelerating.
  </p>
  <p class="mt-4 sm:mt-8 text-base lg:text-lg text-gray-700">
    Whether you’re fighting for relevance or scaling fast, your <span
      class="italic font-medium">organizational readiness</span
    > - your ability to respond with speed, clarity, and confidence - will determine
    your future.
  </p>

  <p
    class="text-base lg:text-lg/8 text-gray-700 mt-4 sm:mt-8 italic bg-blue-50 p-4 rounded"
  >
    Most leaders think they’re ready… until they see how much they’re
    compensating for misalignment, indecision, and silence.
  </p>
{:else if score.total >= 80 && score.total < 99}
  <p class="text-xl/8 lg:text-2xl/8 font-bold text-gray-700">
    You’re leading a team that’s doing a lot right.
  </p>

  <p class="mt-5 text-base lg:text-lg/8 text-gray-700">
    They move with intent. Step up under pressure. Align behind priorities.
    There’s momentum here - and it shows.
  </p>

  <p class="mt-5 text-base lg:text-lg/8 text-gray-700">
    But here’s what we know:
    <span class="font-bold">
      High performers don’t plateau from lack of talent - they stall from lack
      of systems.
    </span>
  </p>
  <p class="mt-5 text-base lg:text-lg/8 text-gray-700">
    The margin between 80% and 99% readiness is where the real leadership
    challenge lies:
  </p>
  <ul class="list-disc ml-4 sm:ml-8">
    <li class="mt-2 text-base/7 text-gray-600">
      Can your team make the right call without you?
    </li>

    <li class="mt-1 text-base/7 text-gray-600">
      Do they align without needing a reset?
    </li>
    <li class="mt-1 text-base/7 text-gray-600">
      When pressure spikes, do they rise - or revert?
    </li>
  </ul>

  <p
    class="text-base lg:text-lg/8 text-gray-700 mt-6 italic bg-blue-50 px-4 py-3 rounded"
  >
    This report is designed to help you find that last 20%. Because the cost of
    a small crack… often shows up at the worst possible moment.
  </p>
{:else if score.total == 100}
  <p class="text-xl/8 lg:text-2xl font-bold text-gray-700">
    You’ve built the habits, systems, and mindset of a Fast Attack Leader.
  </p>

  <p class="mt-6 text-base lg:text-xl/8 text-gray-700">
    Your team shows clarity. Trust. Accountability. Agility.
  </p>

  <p class="mt-6 text-base lg:text-xl/8 text-gray-700">
    You’re not just keeping up - you’re setting the pace.
  </p>

  <p class="mt-6 text-base lg:text-xl/8 text-gray-700 font-bold">
    But here’s the question we always ask at the top:
  </p>

  <p
    class="text-base lg:text-lg/8 text-gray-700 mt-4 italic bg-blue-50 p-4 rounded"
  >
    "Is your team just reflecting your clarity - or have they internalized it
    themselves?"
  </p>
{/if}
